import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Errored from '../../core/Errored';
import { makeCancelable, sortObjects } from '../../core/utils/utils';
import withGS from '../../core/withGShoc';
import GS from '../../grafsync/grafsync';
import { APPLICATION_PATHS } from '../../application-core/constants';
import MemberOfCollection from './MemberOfCollection';

const styles = {};
const loadOptions = {};

class MemberOf extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      collections: undefined,
      isErrored: null
    };
    this.cancellable = null;
  }

  static getDerivedStateFromProps(props, state) {
    // We use the objects internal version counter set by GS to know if changed
    if (props.data._version !== state._version) {
      return {
        collections: undefined,
        isLoading: true,
        _version: props.data._version,
      };
    }
    return null;
  }

  componentDidUpdate() {
    if (!this.state.isErrored && this.props.data.hasComponent && this.props.data.hasComponent.length > 0
      && this.state.collections === undefined) {
      this.collectComponentData();
    }
  }

  componentDidMount() {
    this.collectComponentData();
  }

  loadData(iris, options) {
    this.cancellable = makeCancelable(GS.loadData(iris, options, this.props.graph, false));
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  collectComponentData() {
    if (this.props.data.hasComponent && this.props.data.hasComponent.length > 0) {
      // At some point we want to filter the properties loaded for each component
      this.loadData(this.props.data.hasComponent, loadOptions)
        .promise
        .then(() => {
          if (this.cancellable && this.cancellable.isCancelled()) return;
          this.processComponents();
          this.setState({ isLoading: false });
        })
        .catch((e) => {
          if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
        });
    }
    else {
      this.setState({ isLoading: false });
    }
  }

  processComponents() {
    let collections = [];
    this.props.data.hasComponent.forEach(component => {
      const componentData = GS.data(component, this.props.graph);
      if (componentData.type.includes("OrderedCollection") || componentData.type.includes("Collection")) {
        collections.push({
          id: componentData.id,
          title: componentData.title
        });
      }
    });
    sortObjects(collections, 'title');
    this.setState({ collections });
  }

  render() {

    const { collections, isLoading, isErrored } = this.state;
    const { conceptIRI, defaultLang, id, graph } = this.props;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoading) return null;
    if (!collections || collections.length === 0) return null;

    return (
      <div>
        {
          collections.map(collection => {
            const link = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/collection#project=' + id
              + "&collection=" + collection.id
              + "&concept=" + conceptIRI;
            return <MemberOfCollection
              link={link}
              key={collection.id}
              conceptIRI={conceptIRI}
              id={collection.id}
              graph={graph}
              defaultLang={defaultLang} />;
          }
          )
        }
      </div>
    );
  }
}

MemberOf.propTypes = {
  defaultLang: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  conceptIRI: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(MemberOf));